import { reactive } from 'vue'

interface IconCache {
  [key: string]: string | null
}

const iconCache = reactive<IconCache>({})

export default iconCache
